import { render, staticRenderFns } from "./validate-confirmation.vue?vue&type=template&id=bfe7b980&"
import script from "./validate-confirmation.vue?vue&type=script&lang=js&"
export * from "./validate-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports